<template>
  <el-dialog
    custom-class="el-dialog--full"
    title="검색"
    :visible="visible"
    :fullscreen="true"
    append-to-body
    @close="close"
  >
    <div class="search-header">
      <div class="search-wrap">
        <el-input
          :placeholder="$t('common.search.placeholder')"
          @keyup.native="changeKeyword"
          ref="searchInput"
          v-model="keyword"
        >
        </el-input>
        <button class="search-wrap__btn" @click="changeKeyword">
          <i class="icon search" />
        </button>
      </div>
    </div>

    <div class="search-contents">
      <div class="inner city-inner" v-if="!searchedKeyword">
        <div class="city-list">
          <strong class="title">{{ $t('common.search.favoriteTitle') }}</strong>
          <el-link
            round
            v-for="(city, index) in cities.favorite"
            :key="index"
            :to="localePath(`/product/${city.friendlyPath}`)"
            type="white"
            class="shadow"
            v-text="city.name"
            @click.native="close"
          />
        </div>
      </div>

      <div class="inner" v-else>
        <div class="search-result">
          <strong
            class="search-title"
            v-html="$t('common.search.result', { keyword: searchedKeyword })"
          ></strong>
          <div class="scrollable">
            <unit-loader v-if="isSearching" type="block" height="350px" />
            <template v-else>
              <no-result
                v-if="isMt(cityList) && isMt(productList)"
                :message="$t('common.search.noResult')"
              />
              <ul v-else class="search-list">
                <li v-for="(city, i) in notEmptyCityList" :key="`c${i}`">
                  <router-link
                    :to="localePath(`/product/${city.friendlyPath}`)"
                    @click.native="close"
                  >
                    <p class="text">
                      <i class="icon marker" />
                      <span v-html="highlight(`${city.name}, ${city.country}`, keyword)" />
                    </p>
                  </router-link>
                </li>
                <li v-for="(product, i) in notEmptyProductList" :key="`p${i}`">
                  <a
                    href="#"
                    title="상품 상세 보기"
                    @click.prevent="
                      $_globalMixin_navigateToProductDetail(
                        `${product.cities[0].friendlyPath}/${product.id}`
                      )
                    "
                  >
                    <p class="text">
                      <i class="icon ticket" />
                      <span v-html="highlight(`${product.title}`, keyword)" />
                    </p>
                    <p
                      class="category"
                      v-html="
                        highlight(
                          `${product.categories[0].name}·${product.cities[0].name}·${getCountryName(
                            product.cities[0].name
                          )}`,
                          keyword
                        )
                      "
                    />
                  </a>
                </li>
              </ul>
            </template>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import NoResult from 'views/components/no-result'
import _debounce from 'lodash/debounce'

export default {
  props: ['visible'],
  components: {
    NoResult,
  },

  data() {
    return {
      keyword: '',
      ignoreKeyword: ['괌', '섬'],
      changeKeyword: '',
      searchedKeyword: '',
      cityList: null,
      productList: null,
      productNum: 20,
      isSearching: false,
    }
  },

  computed: {
    cities() {
      return this.$store.state.cities
    },
    notEmptyCityList() {
      if (!this.isMt(this.cityList)) return this.cityList
    },
    notEmptyProductList() {
      if (!this.isMt(this.productList)) {
        return this.productList.filter((product) => product.cities && product.cities.length > 0)
      }
    },
  },

  watch: {
    $route() {
      this.close()
    },
    visible(flag) {
      flag && this.setFocus()
    },
  },

  created() {
    this.changeKeyword = _debounce(this.loadSearchResult, 300)
  },

  methods: {
    close() {
      this.keyword = ''
      this.searchedKeyword = ''
      this.changeKeyword.cancel()
      this.$emit('close')
    },
    setFocus() {
      this.$nextTick(() => {
        this.$refs.searchInput.focus()
      })
    },
    getCities() {
      this.$http
        .post('/platform/v1/city-find', {
          keyword: this.keyword,
          limit: 20,
        })
        .then((res) => {
          this.cityList = res.data
          this.productNum = 20 - this.cityList.length
          if (this.productNum > 0) {
            this.isSearching = true
            this.getProducts()
          }
          this.searchedKeyword = this.keyword
        })
    },
    getProducts() {
      this.$http
        .post('/product/v1/search', {
          filter: 'KEYWORD',
          keyword: this.keyword,
          limit: this.productNum,
        })
        .then((res) => {
          this.isSearching = false
          this.productList = res.data
        })
    },
    loadSearchResult() {
      const keyword = this.keyword.trim()

      if (
        (this.ignoreKeyword || []).includes(keyword) ||
        keyword.replace(/[ㄱ-ㅎ|ㅏ-ㅣ]/g, '').length > 1
      ) {
        this.cityList = null
        this.productList = null
        this.getCities()
      } else {
        this.searchedKeyword = ''
      }

      this.changeKeyword.cancel()
    },
  },
}
</script>

<style src="./style.scss" lang="scss" scoped></style>
